var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMediaNetworks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "blog_post",
    "data-name": "blog post",
    width: 40,
    height: 40,
    transform: "translate(710 1574)",
    fill: "rgba(0,0,0,0.13)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_95830",
    "data-name": "Mask Group 95830",
    transform: "translate(-710 -1574)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_172074",
    "data-name": "Group 172074",
    transform: "translate(718 1581)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172100",
    "data-name": "Path 172100",
    d: "M13.051,5.19A8.051,8.051,0,1,0,21.1,13.241,8.059,8.059,0,0,0,13.051,5.19Zm0,2.653a2.317,2.317,0,1,1-2.317,2.317A2.315,2.315,0,0,1,13.051,7.843Zm4.608,8.594a5.925,5.925,0,0,1-9.216,0l-.168-.207L8.391,16a5.156,5.156,0,0,1,3.469-2.783l.168-.039.142.078a1.779,1.779,0,0,0,1.76,0l.142-.078.155.039A5.184,5.184,0,0,1,17.7,16l.116.233Z",
    transform: "translate(-1.039 -0.453)",
    fill: "#E39DFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172101",
    "data-name": "Path 172101",
    d: "M8.476,8.717,5.8,6.711a3.174,3.174,0,0,0,.026-.349A1.941,1.941,0,1,0,3.881,8.3,2.016,2.016,0,0,0,4.8,8.07l2.666,1.993a.792.792,0,0,0,.5.168A.84.84,0,0,0,8.645,9.9.855.855,0,0,0,8.476,8.717Z",
    transform: "translate(-1.94 -0.679)",
    fill: "#E39DFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172102",
    "data-name": "Path 172102",
    d: "M17.07,1.53a2.6,2.6,0,0,0-2.589,2.589,2.542,2.542,0,0,0,.634,1.67l-1.54,2.149a.844.844,0,0,0,1.372.984l1.631-2.265a2.229,2.229,0,0,0,.5.052A2.589,2.589,0,1,0,17.07,1.53Z",
    transform: "translate(1.438 -1.53)",
    fill: "#E39DFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172103",
    "data-name": "Path 172103",
    d: "M20.484,11.13a1.955,1.955,0,0,0-1.631.893L17.4,11.79a.846.846,0,1,0-.272,1.67l1.527.246a1.937,1.937,0,1,0,1.825-2.576Z",
    transform: "translate(2.322 1.296)",
    fill: "#E39DFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172104",
    "data-name": "Path 172104",
    d: "M16.8,19.32c-.039,0-.091.013-.129.013l-2.1-3.352a.846.846,0,1,0-1.437.893L15.2,20.161a1.917,1.917,0,0,0-.349,1.1A1.941,1.941,0,1,0,16.8,19.32Z",
    transform: "translate(1.319 2.606)",
    fill: "#E39DFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172105",
    "data-name": "Path 172105",
    d: "M9.044,15.1a.852.852,0,0,0-1.191-.013l-1.76,1.721a2.765,2.765,0,0,0-.945-.272,2.591,2.591,0,1,0,2.369,2.8,2.522,2.522,0,0,0-.259-1.32l1.773-1.734A.836.836,0,0,0,9.044,15.1Z",
    transform: "translate(-1.821 2.39)",
    fill: "#E39DFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaNetworks);
export default __webpack_public_path__ + "static/media/media_networks.90ee26054ba32fe20331ffc7abbb4eca.svg";
export { ForwardRef as ReactComponent };